<template>
<div>
  <team-accomplish :type="1" :diff="$route.query.diff" :examine="false"></team-accomplish>
</div>
</template>

<script>
import TeamAccomplish from "components/TeamAccomplish";
export default {
  name: "Finished",
  components: {
    TeamAccomplish
  }
}
</script>

<style scoped>

</style>
